import React from 'react';
import SectionAbout from './../components/SectionAbout/SectionAbout';
import Projects from './../components/ProjectsSection/ProjectsSection';

const HomePage = () => {
  return (
    <>
      <SectionAbout />
      <Projects />
    </>
  );
};

export default HomePage;
